import { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import PageTitle from '../components/UtilityHelpers/PageTitle';
import EmailNotificationSettings from "../components/Settings/EmailNotificationSettings";
import BudgetSettings from "../components/Settings/BudgetSettings";
import { useAuth } from "../hooks/useAuth";
import ArchiveSettings from "../components/Settings/ArchiveSettings";

const SettingsPage = () => {
    const auth = useAuth();

    return (
        <>
            <PageTitle title="OPS | Settings Page" />
            <MainLayout>
                
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 xl:grid-cols-3 2xl:gap-7.5">

                    <EmailNotificationSettings />
                    { auth?.roles?.find(role => ["500"]?.includes(role)) && (
                            <BudgetSettings />
                        )
                    }
                    { auth?.roles?.find(role => ["500"]?.includes(role)) && (
                            <ArchiveSettings />
                        )
                    }
                </div>
            </MainLayout>
        </>
    )
}

export default SettingsPage;